import { axiosClient, getCSRFToken } from 'www/utils'

/**
 * @typedef {object} IConsultation
 * @property { number } service_id -
 * @property { string } nearest_dt -
 */
/**
 * @typedef {object} TResponseDoctorsAndConsultations
 * @property { number } doctor_id -
 * @property { IConsultation[] } consultations -
 */
/**
 * @description Запрашивает врачей и их первичные консультации для указанной услуги
 *
 * @param {object} requestData - данные запроса
 * @param { number } requestData.age - возраст пациента
 * @param { number } requestData.lpuId - id клиники
 * @param { number } requestData.synonymId - id синонима/услуги
 * @param { string } requestData.appointmentDate - выбранное время записи (слот)
 *
 * @returns { Promise<TResponseDoctorsAndConsultations[]> } -
 */
function getDoctorsAndConsultations({
  age,
  lpuId,
  synonymId,
  appointmentDate,
}) {
  return axiosClient({
    url: '/ajax/diagnostika/services/require_consultation/relations/',
    method: 'POST',
    data: {
      age,
      lpu_id: lpuId,
      service_requires_consultation_id: synonymId,
      target_dt: appointmentDate,
    },
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': getCSRFToken(),
    },
  })
    .then(({ data }) => data)
}

export default getDoctorsAndConsultations
